export const SquareGroup = ["warning", "primary", "warning1", "danger", "light", "warning", "success", "success"];




export const eServiceData = [
  {
    title: "Renewal of Vehicle License (Lekgetho)",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P105 plus any penalities",
    date2: "Due Every 12 Months",
    color: "primary",
    code: "2025001",
    published: "true",
  },
  {
    title: "Renewal of Driving License",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P230 plus any penalities",
    date2: "Due Every 12 Months",
    color: "primary",
    code: "2025002",
    published: "false",
  },
  {
    title: "Renewal of Provisional Driving License (Learner's)",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P120",
    date2: "Due Every 24 Months",
    color: "primary",
    code: "2025003",
    published: "false",
  },
  {
    title: "Renewal of Professional Driving Permit (PrDP) ",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P230",
    date2: "Due Every 12 Months",
    color: "primary",
    code: "2025004",
    published: "false",
  },
  {
    title: "Reschedule a Test Booking",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P105",
    date2: "The test must be at least 2 days away",
    color: "primary",
    code: "2025005",
    published: "false",
  },
  {
    title: "Theory Test Booking",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P105",
    date2: "Must have valid Learner's License",
    color: "primary",
    code: "2025006",
    published: "false",
  },
  {
    title: "Yard Test Booking",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P130",
    date2: "Must have passed Theory Test",
    color: "primary",
    code: "2025007",
    published: "false",
  },
  {
    title: "Road Test Booking",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P130",
    date2: "Must have passed Yard Test",
    color: "primary",
    code: "2025008",
    published: "false",
  },
  {
    title: "Roadworthiness Test Booking",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P105",
    date2: "Vehicle must be registered",
    color: "primary",
    code: "2025009",
    published: "false",
  },
  {
    title: "Theory Test Result Duplicate",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P105",
    date2: "DA Police Affidavit is Required",
    color: "primary",
    code: "20250010",
    published: "false",
  },
  {
    title: "Application for Provisional Driving License (Learner's)",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P70",
    date2: "Must have valid Eye Test",
    color: "primary",
    code: "20250011",
    published: "false",
  },
  {
    title: "Payment for a New Driving License",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P90",
    date2: "Must have passed all applicable tests ",
    color: "primary",
    code: "20250012",
    published: "false",
  },
  {
    title: "Payment for International Driving Permit (IDP)",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P230",
    date2: "Applicable only to non-Botswana citizens",
    color: "primary",
    code: "20250013",
    published: "false",
  },
  {
    title: "Payment for a Professional Driving Permit (PrDP)",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P230",
    date2: "Must have class B, and taken applicable tests",
    color: "primary",
    code: "20250014",
    published: "false",
  },
  {
    title: "Application for a Temporary Road License",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P120",
    date2: "Applicable to new unregistered vehicles only",
    color: "primary",
    code: "20250015",
    published: "false",
  },
  {
    title: "Driving License Duplicate",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P105",
    date2: "A valid Police Affidavit is required",
    color: "primary",
    code: "20250016",
    published: "false",
  },
  {
    title: "Provisional Driving License (Learner's) Duplicate",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P130",
    date2: "A Police Affidavit is Required",
    color: "primary",
    code: "20250017",
    published: "false",
  },
  {
    title: "Professional Driving Permit (PrDP) Duplicate",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P230",
    date2: "A Police Affidavit is Required",
    color: "primary",
    code: "20250018",
    published: "false",
  },
 
];




export const DriverLicensingData = [
  
  {
    title: "Renewal of Driving License",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P230 plus any penalities",
    date2: "Due Every 12 Months",
    color: "primary",
    code: "2025002",
    published: "false",
  },
  {
    title: "Renewal of Provisional Driving License (Learner's)",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P120",
    date2: "Due Every 24 Months",
    color: "primary",
    code: "2025003",
    published: "false",
  },
  {
    title: "Theory Test Booking",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P105",
    date2: "Must have valid Learner's License",
    color: "primary",
    code: "2025006",
    published: "false",
  },
  {
    title: "Yard Test Booking",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P130",
    date2: "Must have passed Theory Test",
    color: "primary",
    code: "2025007",
    published: "false",
  },
  {
    title: "Road Test Booking",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P130",
    date2: "Must have passed Yard Test",
    color: "primary",
    code: "2025008",
    published: "false",
  },

  {
    title: "Reschedule a Booking",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P105",
    date2: "The test must be at least 2 days away",
    color: "primary",
    code: "2025001",
    published: "false",
  },

  {
    title: "Application for Provisional Driving License (Learner's)",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P70",
    date2: "Must have valid Eye Test",
    color: "primary",
    code: "20250011",
    published: "false",
  },
  {
    title: "Payment for a New Driving License",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P90",
    date2: "Must have passed all applicable tests ",
    color: "primary",
    code: "20250012",
    published: "false",
  },
  {
    title: "Payment for International Driving Permit (IDP)",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P230",
    date2: "Applicable only to non-Botswana citizens",
    color: "primary",
    code: "20250013",
    published: "false",
  },
  {
    title: "Payment for a Professional Driving Permit (PrDP)",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P230",
    date2: "Must have class B, and taken applicable tests",
    color: "primary",
    code: "20250014",
    published: "false",
  },
 
  {
    title: "Driving License Duplicate",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P105",
    date2: "A valid Police Affidavit is required",
    color: "primary",
    code: "20250016",
    published: "false",
  },
  {
    title: "Provisional Driving License (Learner's) Duplicate",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P130",
    date2: "A Police Affidavit is Required",
    color: "primary",
    code: "20250017",
    published: "false",
  },
  {
    title: "Professional Driving Permit (PrDP) Duplicate",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P230",
    date2: "A Police Affidavit is Required",
    color: "primary",
    code: "20250018",
    published: "false",
  },
  {
    title: "Theory Test Result Duplicate",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P105",
    date2: "DA Police Affidavit is Required",
    color: "primary",
    code: "20250010",
    published: "false",
  },
];




export const VehicleLicensingData = [
  {
    title: "Renewal of Vehicle License (Lekgetho)",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P105 plus any penalities",
    date2: "Due Every 12 Months",
    color: "primary",
    code: "2025001",
    published: "true",
  },
  {
    title: "Application for Temporary Road License",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P230",
    date2: "Used for a new/unregistred vehicle ",
    color: "primary",
    code: "20250015",
    published: "false",
  }, 
  {
    title: "Roadworthiness Test Booking",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P105 plus any penalities",
    date2: "Due Every 12 Months",
    color: "primary",
    code: "2025009",
    published: "false",
  },
];




export const TransportPermitsData = [
  
  {
    title: "Roadworthiness Test Booking",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P105",
    date2: "Due Every 12 Months",
    color: "primary",
    code: "2025009",
    published: "false",
  },
];




export const DuplicatesData = [
  {
    title: "Driving License Duplicate",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P105",
    date2: "A valid Police Affidavit is required",
    color: "primary",
    code: "20250016",
    published: "false",
  },
  {
    title: "Provisional Driving License (Learner's) Duplicate",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P130",
    date2: "A Police Affidavit is Required",
    color: "primary",
    code: "20250017",
    published: "false",
  },
  {
    title: "Professional Driving Permit (PrDP) Duplicate",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P230",
    date2: "A Police Affidavit is Required",
    color: "primary",
    code: "20250018",
    published: "false",
  },
  {
    title: "Theory Test Result Duplicate",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P105",
    date2: "DA Police Affidavit is Required",
    color: "primary",
    code: "20250010",
    published: "false",
  },
];




export const RenewalsData = [
  {
    title: "Renewal of Vehicle License (Lekgetho)",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P105 plus any penalities",
    date2: "Due Every 12 Months",
    color: "primary",
    code: "2025001",
    published: "true",
  },
  {
    title: "Renewal of Driving License",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P230 plus any penalities",
    date2: "Due Every 12 Months",
    color: "primary",
    code: "2025002",
    published: "false",
  },
  {
    title: "Renewal of Provisional Driving License (Learner's)",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P120",
    date2: "Due Every 24 Months",
    color: "primary",
    code: "2025003",
    published: "false",
  },
  {
    title: "Renewal of Professional Driving Permit (PrDP) ",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P230",
    date2: "Due Every 12 Months",
    color: "primary",
    code: "2025004",
    published: "false",
  },
 
];




export const BookingsData = [
  {
    title: "Theory Test Booking",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P105",
    date2: "Must have valid Learner's License",
    color: "primary",
    code: "2025006",
    published: "false",
  },
  {
    title: "Yard Test Booking",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P130",
    date2: "Must have passed Theory Test",
    color: "primary",
    code: "2025007",
    published: "false",
  },
  {
    title: "Road Test Booking",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P130",
    date2: "Must have passed Yard Test",
    color: "primary",
    code: "2025008",
    published: "false",
  },
  {
    title: "Roadworthiness Test Booking",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P105",
    date2: "Vehicle must be registered",
    color: "primary",
    code: "2025009",
    published: "false",
  },
  {
    title: "Reschedule a Booking",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P105",
    date2: "The test must be at least 2 days away",
    color: "primary",
    code: "2025001",
    published: "false",
  },
];




export const NewApplicationsData = [
  {
    title: "Application for Provisional Driving License (Learner's)",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P70",
    date2: "Must have valid Eye Test",
    color: "primary",
    code: "20250011",
    published: "false",
  },
  {
    title: "Payment for a New Driving License",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P90",
    date2: "Must have passed all applicable tests ",
    color: "primary",
    code: "20250012",
    published: "false",
  },
  {
    title: "Payment for International Driving Permit (IDP)",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P230",
    date2: "Applicable only to non-Botswana citizens",
    color: "primary",
    code: "20250013",
    published: "false",
  },
  {
    title: "Payment for a Professional Driving Permit (PrDP)",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P230",
    date2: "Must have class B, and taken applicable tests",
    color: "primary",
    code: "20250014",
    published: "false",
  },
  {
    title: "Application for a Temporary Road License",
    image: "4.jpg",
    icon: "bag",
    icon2: "clock",
    date: "Fee is P120",
    date2: "Applicable to new unregistered vehicles only",
    color: "primary",
    code: "20250015",
    published: "false",
  },
];
